

export default function ResourceResults(props){

    const { generatingResults, results, setResourceSelected } = props;

    const n = 10;
    const colorArray = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]

    const completionToColor = (score) => {
    
        const colorArray = ["#FF0000", "#FF8A00", "#FFF500", "#9EFF00", "#61FF00", "#00FF47", "#00FF94", "#00ffbb", "#00ffd0", "#00ffe5"]
    
        const normalisedScore = Math.round(parseInt(score*5,10))

            if(normalisedScore >= 10){
                return "#2291E1"
                } else {
                return colorArray[normalisedScore]
                }

      }

    return(
        <div className="map__results--contents">
            <div className="map__results--title">
                <div className="map__results--subtitle">
                {generatingResults && <div className="ai-body-small ai-grey-80" style={{visibility: 'hidden'}}>Loading Resources</div>}
                {!generatingResults && results && <div className="ai-body-small ai-grey-80">{results.length > 0 ? `${results.length}${results.length === 500 ? '+' : ''} Resource${results.length > 1 ? 's' : ''}` : 'No Resources'}</div>}
                <div className="map__results--subtitle-key">
                {
                    colorArray.map((score, index) => {

                    return(
                        <div key={index} style={results.filter(r => Math.round(parseInt(r.completionLevel*5,10)) === score).length > 0 ? {} : {display: 'none'}}>
                        <div style={{width: '1rem', height: '1rem', borderRadius: '100%', backgroundColor: completionToColor(score/5)}}></div>
                        <div className="ai-body-tiny ai-grey-100">{`${results.filter(r => Math.round(parseInt(r.completionLevel*5,10)) === score).length} ${results.filter(r => Math.round(parseInt(r.completionLevel*5,10)) === score).length > 1 ? 'resources' : 'resource'}`}</div>

                        </div>
                    )


                    })
                }

                </div>
                </div>
            </div>
            {
            generatingResults ?
            <div className="map__results--contents">
                {[...Array(n)].map((e,i) => <div className="map__results--row-loading" key={i}><div></div></div>)}
            </div>
            :
            results && results.length > 0 ?
            <div className="map__results--contents">
              {results.map((r,index) => {
    
                return(
                    <div key={index} className={(r.completionExplanation) ? "map__results--row map__results--row-wide" : (r.phenomena && r.phenomena.length > 0) ? "map__results--row map__results--row-wide map__results--row-wide-phenomena" : "map__results--row"}>
                  {/* {(isStaging && (parseInt(session.user.id, 10) === 6795 || parseInt(session.user.id, 10) === 4254)) && <button style={{position: 'absolute', left: '1rem'}} onClick={() => handleGetPhenomena(r.id)}><div className="button-text">Phenomena!</div></button>} */}
                        <div style={(r.completionLevel || r.completionLevel === 0) ? {backgroundColor: completionToColor(r.completionLevel),height: '100%', width: '0.8rem'} : {height: '100%', width: '0.8rem'}}></div>
                        <div onClick={() => setResourceSelected(r)} className="ai-body-small ai-grey-100">{r.title}</div>
                        {!r.completionExplanation && !(r.phenomena && r.phenomena.length > 0) && <div className="ai-body-tiny ai-grey-100">IM 360</div>}
                        {r.completionExplanation && <div className="ai-body-tiny ai-grey-100">{r.completionExplanation}</div>}
                        {r.phenomena && 
                        <div>
                            {r.phenomena.map((p,index) => {
                            return(
                                <div key={index} className="ai-body-tiny ai-grey-100">{p}</div>
                            )
                            })
                            }
                        </div>
                        }
                </div>
                )
              })}
        
            </div>
            :
            <div className="map__results--empty"></div>

            }
        </div>

    )
}